import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "./styles/global.scss";
import App from "./App";
import { About, DetailsPage, EventsPage } from "./Pages";
import { ContactUs } from "./components/index";
import Donate from "./Pages/Donate";
import { ScrollTop } from "./utils";

ReactDOM.render(
  <BrowserRouter>
    <ScrollTop />
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="about" element={<About />} />
      <Route path="details/:project" element={<DetailsPage />} />
      <Route path="donate" element={<Donate />} />
      <Route path="events-listing" element={<EventsPage />} />
      <Route path="#contact" element={<ContactUs />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
